// extracted by mini-css-extract-plugin
export default {"samlLoginForm":"SamlLogin_samlLoginForm__AjZ3a","loginButton":"SamlLogin_loginButton__wGLwb","emailInput":"SamlLogin_emailInput__m8iIJ"};